import Component from 'component';
import 'waypoints/jquery.waypoints';
import { Expo, TweenLite } from 'gsap';
import 'selectric';
import 'selectric/public/plugins/jquery.selectric.placeholder';
import { addLabelsToSelectric } from '../../helpers';

class Header extends Component {
  constructor(el, config) {
    super(el, config);

    this.init();
  }

  setupDefaults() {
    this.dom = {
      $headerNav: this.$el.find('.wh-header-navigation'),
      $headerNavBar: this.$el.find('.wh-header-navigation__wrapper'),
      $searchBtn: this.$el.find('.wh-header-navigation__search-icon'),
      $searchInput: this.$el.find('.wh-search-box__field'),
      $navLinks: this.$el.find('.wh-header-navigation__links'),
      $searchBox: this.$el.find('.wh-search-box'),
      $predictiveResults: this.$el.find('.wh-predictive-search'),
      $burgerBtn: this.$el.find('.wh-header-navigation__burger'),
      $document: $(document),
      $body: $('body'),
      $utilityNav: this.$el.find('.wh-utility-navigation'),
      $utilityNavItem: this.$el.find('.wh-utility-navigation-item'),
      $utilityNavItemLink: this.$el.find('.wh-utility-navigation-item__link'),
      $utilityNavItemMobile: this.$el.find(
        '.wh-header-navigation__utility-select'
      ),
      $primaryNavItems: this.$el.find('.header__primary-nav-item'),
      $headerRegionLink: this.$el.find('.header__region-link'),
      $logo: this.$el.find('.wh-header-navigation__logo--screen'),
      $logoWrapper: this.$el.find('.wh-header-navigation__logo-wrapper')
    };

    this.classes = {
      searchOn: 'search-on',
      navOpen: 'nav-open',
      sticky: 'wh-header--is-sticky',
      stickyVisible: 'wh-header--is-sticky-visible',
      utilityOpen: 'utility-open'
    };
  }

  addListeners() {
    this.dom.$searchBtn.on('click', ::this.onToggleSearch);
    this.dom.$document.on('click', ::this.onClickOutside);
    this.dom.$burgerBtn.on('click', ::this.onToggleNav);
    this.dom.$utilityNavItemLink.on('click', ::this.onToggleUtilityNavDropdown);
    this.dom.$utilityNavItemMobile.on(
      'change',
      ::this.onUtilityNavMobileChange
    );
    this.dom.$utilityNavItemMobile.on('blur', ::this.onUtilityNavMobileClose);
    this.dom.$headerRegionLink.on('click', ::this.handleHeaderRegionLink);
    this.dom.$primaryNavItems.on('click', ::this.handlePrimaryNavLinkClick);
  }

  init() {
    new this.config.PredictiveSearch(this.$el, {
      endpoint: this.config.endpoint,
      itemsLimit: 5
    });
    if (
      this.$el.hasClass(this.classes.sticky) &&
      !this.$el.hasClass(this.classes.stickyVisible)
    ) {
      this.config.triggerElement.waypoint(direction => {
        if (direction === 'down') {
          this.dom.$headerNav.css('top', 0);
        } else {
          if (!$('body').hasClass('wh-search-box-focused')) {
            this.dom.$headerNav.css('top', -150);
            this.dom.$utilityNavItem.removeClass(this.classes.utilityOpen);
          }
        }
      });
    }
    this.setSelectric();
    return this;
  }

  handleHeaderRegionLink(e) {
    const selectedOption = e.currentTarget.childNodes[1].href;
    window.location.href = selectedOption;
  }

  handlePrimaryNavLinkClick(e) {
    const { $primaryNavItems } = this.dom;
    const parent = e.currentTarget.closest('.header__primary-nav-item');
    const dataset = parent.dataset;
    if (!dataset.itemOpen) {
      if (parent.childNodes.length > 3) {
        e.preventDefault();
        $primaryNavItems
          .filter(items => items !== parent)
          .each(item =>
            $primaryNavItems[item].removeAttribute('data-item-open')
          );
        parent.dataset.itemOpen = 'true';
      }
    } else {
      e.preventDefault();
      parent.removeAttribute('data-item-open');
    }
  }

  setSelectric() {
    const isMobile =
      navigator.platform
        .toLowerCase()
        .match(/(iphone|ipod|ipad|android|arm)/) !== null
        ? true
        : false;
    this.dom.$utilityNavItemMobile.selectric({
      disableOnMobile: false,
      nativeOnMobile: isMobile
    });
    this.dom.$utilityNavItemMobile.selectricPlaceholder({});

    addLabelsToSelectric();
  }

  onToggleSearch(e) {
    e.preventDefault();
    this.dom.$body.toggleClass(this.classes.navOpen);
    this.dom.$utilityNavItem.removeClass(this.classes.utilityOpen);

    if ($(window).width() > 1023) {
      this.$el.toggleClass(this.classes.searchOn);
    }

    if (this.dom.$body.hasClass(this.classes.navOpen)) {
      this.dom.$searchInput.focus();
    }
  }

  onToggleNav(e) {
    e.preventDefault();
    this.dom.$body.toggleClass(this.classes.navOpen);
  }

  onClickOutside(e) {
    const { $primaryNavItems } = this.dom;
    if (this.dom.$primaryNavItems.has(e.target).length === 0) {
      $primaryNavItems.each(item =>
        $primaryNavItems[item].removeAttribute('data-item-open')
      );
    }

    if (
      this.dom.$body.hasClass(this.classes.navOpen) &&
      this.dom.$headerNavBar.has(e.target).length === 0 &&
      !this.dom.$searchBtn.is(
        $(e.target).parents('.wh-header-navigation__search-icon')
      )
    ) {
      this.dom.$body.removeClass(this.classes.navOpen);
    }

    if (
      !this.dom.$searchBox.is(e.target) &&
      this.dom.$searchBox.has(e.target).length === 0 &&
      !this.dom.$searchBtn.is(
        $(e.target).parents('.wh-header-navigation__search-icon')
      ) &&
      !this.dom.$utilityNavItem.is(e.target) &&
      this.dom.$utilityNavItem.has(e.target).length === 0
    ) {
      TweenLite.to(this.dom.$predictiveResults, 0.5, {
        height: 0,
        ease: Expo.easeOut,
        onComplete: () => {
          this.dom.$predictiveResults.removeClass('expanded');
        }
      });
      this.$el.removeClass(this.classes.searchOn);
      this.dom.$utilityNavItem.removeClass(this.classes.utilityOpen);
    }
  }

  onToggleUtilityNavDropdown(e) {
    e.preventDefault();
    const $target = $(e.currentTarget);
    const $parent = $($target.parents('.wh-utility-navigation-item')[0]);
    if ($parent.hasClass(this.classes.utilityOpen)) {
      $parent.removeClass(this.classes.utilityOpen);
      return;
    }

    this.dom.$utilityNavItem.removeClass(this.classes.utilityOpen);
    $parent.addClass(this.classes.utilityOpen);
  }

  onUtilityNavMobileClose(e) {
    if (!this.$el.hasClass(this.classes.sticky)) {
      window.scrollTo(0, 0);
    }
  }

  onUtilityNavMobileChange(e) {
    const $target = $(e.currentTarget);
    const selectedOption = $target.val();
    window.location.href = selectedOption;
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/js/components/global/Header.js